export default function reduce(state = {}, action) {
    let stateLocation;
    switch(action.type) {
        case "SET_ACCESSKEY":
            stateLocation = action.payload.stateLocation;
            return Object.assign({}, state, {
                [stateLocation]: action.payload.accessKey,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/accesskey/src/reducers/index.js